var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addVideoButton",on:{"click":_vm.filePicker}},[_c('div',{staticClass:"icon"},[_c('iconfont',{staticClass:"normal",attrs:{"name":"#icon13-3tianjiashipin"}}),_c('iconfont',{staticClass:"hover",attrs:{"name":"#icon13-3tianjiashipinjiaohu"}})],1),_c('div',[_vm._v("添加视频")])])
}
var staticRenderFns = []

export { render, staticRenderFns }